module.exports = __webpack_public_path__ + "media/images/gallery/constellations/snr_layer_off-47e5d9ef36c60f48bef82d8e87a83947.png";